/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { getFolderById, getIsUpdating } from 'bucket/reducers/folders';
import { getResourcesByFolder, getIsRemoving } from 'bucket/reducers/resources';
import * as FoldersActions from 'bucket/actions/folders';
import * as ResourcesActions from 'bucket/actions/resources';
import * as UploadActions from 'bucket/actions/uploads';
import FolderHeader from './components/FolderHeader';
import FolderForm from './components/FolderForm';
import ResourcesList from './components/ResourceList';

type Props = {
  folder?: BucketFolder,
  resources: List<BucketResource>,
  updateFolder: (folder: BucketFolder) => void,
  isUpdating: boolean,
  filterResources: (value: string) => void,
  updateResource: (resource: BucketResource) => void,
  cropResource: (
    folder: BucketFolder,
    resource: BucketResource,
    crop: CropConfig
  ) => void,
  removeResource: (resource: BucketResource) => void,
  isRemovingResource: boolean,
};

const mapStateToProps = (state, { match }) => ({
  folder: getFolderById(state, match.params.id),
  isUpdating: getIsUpdating(state),
  resources: getResourcesByFolder(state, match.params.id),
  isRemovingResource: getIsRemoving(state),
});

const Folder = ({
  folder,
  resources,
  updateFolder,
  isUpdating,
  filterResources,
  updateResource,
  cropResource,
  removeResource,
  isRemovingResource,
}: Props) => {
  if (folder) {
    const onCropResource = (resource: BucketResource, crop: CropConfig) => {
      cropResource(folder, resource, crop);
    };

    return (
      <div>
        <FolderHeader folder={folder} onSearch={filterResources} />
        <FolderForm
          folder={folder}
          isUpdating={isUpdating}
          onChange={updateFolder}
        />
        <ResourcesList
          resources={resources}
          onUpdateResource={updateResource}
          onCropResource={onCropResource}
          onRemoveResource={removeResource}
          isRemovingResource={isRemovingResource}
        />
      </div>
    );
  }

  return null;
};

export default connect(mapStateToProps, {
  updateFolder: FoldersActions.updateFolder,
  filterResources: ResourcesActions.filterResources,
  updateResource: ResourcesActions.updateResource,
  cropResource: UploadActions.cropResource,
  removeResource: ResourcesActions.removeResource,
})(Folder);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folder/index.js